/* RESPONSIBLE TEAM: team-reporting */

import { Chart } from '@highcharts/react';

import '@/features/reporting-charts/highcharts-theme';
import { buildSeriesOptions } from '@/features/reporting-charts/transforms/series';
import type {
  ChartConfig,
  ChartDataResponse,
  RenderContext,
} from '@/features/reporting-charts/types';

interface SeriesChartProps {
  data: ChartDataResponse;
  config: ChartConfig;
  renderContext: RenderContext;
  className?: string;
}

export function SeriesChart({ data, config, renderContext, className }: SeriesChartProps) {
  const options = buildSeriesOptions(data, config, renderContext);

  return <Chart containerProps={{ className }} options={options} />;
}
